import { styled } from "@linaria/react";

export const EmojiWave = styled.span`
  position: absolute;
  font-size: 2rem;

  animation: wave 2.5s infinite;
  transform-origin: 70% 70%;
  user-select: none;

  @keyframes wave {
    0% {
      transform: rotateZ(0deg);
    }
    10% {
      transform: rotateZ(14deg);
    }
    20% {
      transform: rotateZ(-8deg);
    }
    30% {
      transform: rotateZ(14deg);
    }
    40% {
      transform: rotateZ(-4deg);
    }
    50% {
      transform: rotateZ(10deg);
    }
    60% {
      transform: rotateZ(0deg);
    }
  }
`;

export const EmojiWaveDefaultList = ["👋", "🧑‍🎓", "👨‍🎓", "👩‍🎓", "🤚", "🙋", "🙋‍♀️", "🙋‍♂️"];
